// extracted by mini-css-extract-plugin
export default {"container":"ReactionPopoverButton_container__Cdm4J","popover-button":"ReactionPopoverButton_popover-button__fl6Ms","emoji-picker":"ReactionPopoverButton_emoji-picker__qiv1U"};